"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseUserGeneralCte", {
    enumerable: true,
    get: function() {
        return BaseUserGeneralCte;
    }
});
const _models = require("~/models");
let BaseUserGeneralCte = class BaseUserGeneralCte {
    async inquiry({ context, include_ws_deleted = true }, cteGen) {
        const alias = `nc_base_user_${context.base_id}`;
        const existingAlias = cteGen.getExistingAlias(alias);
        if (existingAlias) {
            return existingAlias;
        }
        const baseUsers = await _models.BaseUser.getUsersList(context, {
            base_id: context.base_id,
            include_ws_deleted,
            mode: 'full'
        });
        return {
            alias: alias,
            applyCte: (qb, { knex })=>{
                const selectUnionQuery = baseUsers.map((u)=>{
                    return `SELECT '${u.fk_user_id}' as id, '${u.email}' as email`;
                }).join(' UNION ALL ');
                qb.with(alias, knex.raw(selectUnionQuery));
            }
        };
    }
    constructor(clientType){
        this.clientType = clientType;
    }
};
